import { C } from '../../../../lib/design';
import { Ic, ICON_PATHS } from '../../../../lib/ui';
import { useI18n } from '../../../../i18n';
import { DOC_COLORS } from '../../../../config/documentStyles';

const AI_ACTIONS = [
  'Completar descripcion',
  'Sugerir entradas/salidas',
  'Proponer indicadores',
  'Verificar coherencia',
  'Generar ficha completa',
];

interface ProcessSheetAiPanelProps {
  showAi: boolean;
  aiMsg: string;
  setAiMsg: (v: string) => void;
  onClose: () => void;
}

export function ProcessSheetAiPanel({
  showAi,
  aiMsg,
  setAiMsg,
  onClose,
}: ProcessSheetAiPanelProps) {
  const { t } = useI18n();

  if (!showAi) return null;

  return (
    <aside
      style={{
        position: 'fixed',
        right: 0,
        top: 50,
        width: 340,
        height: 'calc(100vh - 50px)',
        background: 'white',
        borderLeft: `1px solid ${C.border}`,
        display: 'flex',
        flexDirection: 'column',
        zIndex: 90,
        animation: 'slideRight 0.25s ease',
      }}
    >
      <div
        style={{
          padding: '14px 16px',
          borderBottom: `1px solid ${C.borderAlt}`,
          display: 'flex',
          alignItems: 'center',
          gap: 10,
        }}
      >
        <div
          style={{
            width: 30,
            height: 30,
            borderRadius: 8,
            background: `linear-gradient(135deg, ${C.celeste}, ${DOC_COLORS.h3})`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Ic d={ICON_PATHS.sparkle} s={16} c="white" />
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: C.text }}>{t.process.asistente}</div>
          <div style={{ fontSize: 10, color: C.textMut }}>{t.process.fichaSubtitle}</div>
        </div>
        <button
          onClick={onClose}
          style={{
            border: 'none',
            background: 'none',
            cursor: 'pointer',
            color: C.textMut,
            fontSize: 16,
            padding: 4,
          }}
        >
          <Ic d={ICON_PATHS.x} s={16} />
        </button>
      </div>

      <div style={{ padding: 12, display: 'flex', flexDirection: 'column', gap: 6 }}>
        {AI_ACTIONS.map((a) => (
          <button
            key={a}
            style={{
              width: '100%',
              textAlign: 'left',
              padding: '8px 12px',
              borderRadius: 8,
              fontSize: 13,
              color: C.textSec,
              background: 'white',
              cursor: 'pointer',
              border: `1px solid ${C.borderAlt}`,
              fontFamily: 'inherit',
              transition: 'all 0.15s',
            }}
          >
            {a}
          </button>
        ))}
      </div>

      <div
        style={{
          flex: 1,
          padding: 16,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div style={{ textAlign: 'center', color: C.textMut, fontSize: 12 }}>
          {t.process.aiDisponible}
        </div>
      </div>

      <div
        style={{
          padding: 12,
          borderTop: `1px solid ${C.borderAlt}`,
          display: 'flex',
          gap: 8,
        }}
      >
        <input
          type="text"
          value={aiMsg}
          onChange={(e) => setAiMsg(e.target.value)}
          placeholder="Escribe un mensaje..."
          style={{
            flex: 1,
            border: `1px solid ${C.border}`,
            borderRadius: 8,
            padding: '8px 12px',
            fontSize: 13,
            fontFamily: 'inherit',
            outline: 'none',
          }}
          disabled
        />
        <button
          style={{
            border: 'none',
            borderRadius: 8,
            padding: '8px 14px',
            background: C.azul2,
            color: 'white',
            cursor: 'pointer',
            fontSize: 13,
            fontFamily: 'inherit',
          }}
          disabled
        >
          <Ic d={ICON_PATHS.send} s={14} c="white" />
        </button>
      </div>
    </aside>
  );
}
